import React from "react";
import { Link } from "react-router-dom";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

interface DefaultNavbarLinkProps {
  icon: string;
  name: string;
  route: string;
  light: boolean;
}

const DefaultNavbarLink: React.FC<DefaultNavbarLinkProps> = ({
  icon,
  name,
  route,
  light,
}) => {
  return (
    <SoftBox
      mx={1}
      p={1}
      display="flex"
      alignItems="center"
      sx={{ cursor: "pointer", userSelect: "none" }}
    >
      <Link
        to={route}
        style={{
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        <Icon
          sx={{
            color: ({ palette }: any) =>
              light ? palette.white.main : palette.secondary.main,
            verticalAlign: "middle",
          }}
        >
          {icon}
        </Icon>
        <SoftTypography
          variant="button"
          fontWeight="regular"
          color={light ? "white" : "dark"}
          textTransform="capitalize"
          sx={{ width: "100%", lineHeight: 0 }}
        >
          &nbsp;{name}
        </SoftTypography>
      </Link>
    </SoftBox>
  );
};

export default DefaultNavbarLink;
